import React, { createContext, useContext } from 'react';
import useUserRole from '../hooks/useUserRole';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const userRoleData = useUserRole();
  
  return (
    <UserContext.Provider value={userRoleData}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
